/// <reference path="../../apps/typings/customTds.d.ts" />
export { };

if (!String.prototype.startsWith) {
	String.prototype.startsWith = function (searchString: string, position?: number): boolean {
		position = position || 0;
		return this.indexOf(searchString, position) === position;
	};
}

if (!String.prototype.endsWith) {
	String.prototype.endsWith = function (searchString: string, position?: number): boolean {
		const subjectString = this.toString();
		if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
			position = subjectString.length;
		}
		position = (position || 0) - searchString.length;
		const lastIndex = subjectString.indexOf(searchString, position);
		return lastIndex !== -1 && lastIndex === position;
	};
}

if (!String.prototype.interpolate) {
	String.prototype.interpolate = function (obj: { [key: string]: any }): string {
		return this.replace(/\${([^${}]*)}/g,
			(a: string, b: any): string => {
				const r: any = obj[b];
				return (typeof r === 'string' || typeof r === 'number') ? r.toString() : a;
			}
		);
	};
}
